import { Flex } from "@chakra-ui/layout";
import { Image } from "@chakra-ui/react";
import { useMemo, useCallback } from "react";
import { Parceiro } from "core/features/parceiros/typings";
import { Switch } from "@chakra-ui/switch";
import { showErrorAxios } from "infra/helpers/alerta";
import useToggleParceiroStatus from "core/features/parceiros/hooks/useToggleParceiroStatus";

function useParceirosColumns({ onToogled }: { onToogled: () => void }) {
  const { isLoading, mutate: handleToggleStatus } = useToggleParceiroStatus();

  const _handleToggleStatus = useCallback(
    (id: string, checked: boolean) => {
      handleToggleStatus(
        { nextStatus: checked, id },
        {
          onError: (err) => {
            showErrorAxios(err, "Não foi possível alterar o status.");
          },
          onSuccess: () => {
            onToogled();
          },
        }
      );
    },
    [handleToggleStatus, onToogled]
  );

  return useMemo(() => {
    return [
      {
        title: () => <Flex minW="80px" />,
        width: "100px",
        render: (original: Parceiro) => (
          <Image
            src={original.imagemUrl || ""}
            w="100px"
            h="100%"
            objectFit="cover"
            borderRadius="md"
          />
        ),
      },
      {
        title: "Nome do Parceiro",
        width: "200px",
        render: (original: Parceiro) => <Flex>{original.nome}</Flex>,
      },
      {
        title: "Categoria",

        render: (original: Parceiro) => (
          <Flex>{original.categoriaParceiro}</Flex>
        ),
      },
      {
        title: "Status",
        onClick: () => {},
        render: (original: Parceiro) => (
          <div>
            <Switch
              isDisabled={isLoading}
              onChange={() => {
                _handleToggleStatus(original.id, !original.ativo);
              }}
              isChecked={!!original.ativo}
            />
          </div>
        ),
      },
    ];
  }, [_handleToggleStatus, isLoading]);
}

export default useParceirosColumns;
